module.exports = __webpack_public_path__ + "static/img/yk8220.07d005f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8220.png
// module id = jwwS
// module chunks = 1